// TextPage model based on API::V1::TextPageSerializer
export default {
  // Attributes
  content: null
}
